import * as RadioGroupPrimitive from "@radix-ui/react-radio-group";
import * as React from "react";

import { cn } from "@/lib/cn";

export const RadioGroup = React.forwardRef<
  React.ElementRef<typeof RadioGroupPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Root>
>(({ className, ...props }, ref) => (
  <RadioGroupPrimitive.Root
    className={cn("grid gap-2", className)}
    {...props}
    ref={ref}
  />
));
RadioGroup.displayName = RadioGroupPrimitive.Root.displayName;

export const RadioGroupItem = React.forwardRef<
  React.ElementRef<typeof RadioGroupPrimitive.Item>,
  React.ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Item>
>(({ className, children, ...props }, ref) => (
  <RadioGroupPrimitive.Item
    ref={ref}
    className={cn(
      // Size & shape
      "relative size-4 shrink-0 rounded-full",
      // Cursor
      "cursor-pointer",
      // Border
      "border-primary-800/56 border",
      // Checked state
      "data-[state=checked]:border-primary-500",
      // Focus state
      "focus-visible:ring-primary-500/50 focus-visible:ring-2 focus-visible:outline-none",
      // Hover state
      "hover:border-primary-500/80",
      "data-[state=checked]:hover:border-primary-400",
      // Disabled state
      "disabled:cursor-not-allowed disabled:opacity-50",
      // Transition
      "transition-colors",
      className
    )}
    {...props}
  >
    <RadioGroupPrimitive.Indicator className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
      <div className="bg-primary-500 size-2.5 rounded-full" />
    </RadioGroupPrimitive.Indicator>
    {children}
  </RadioGroupPrimitive.Item>
));
RadioGroupItem.displayName = RadioGroupPrimitive.Item.displayName;
